import SystemUserList from "./SystemUserList";
import SystemUserAssignPermission from "./SystemUserAssignPermission";

export default {
  list: SystemUserList,
  show: SystemUserAssignPermission,
};
